export const AccountRoutesEnum = {
  Root: "",
  Start: "start",
  StartInvite: "start/invite/:inviteId",
  Subscription: "plan",
  Billing: "billing",
  Users: "users",
  LocationDetails: "locations/:id",
  Locations: "locations",
  Brands: "brands",
  NewBrand: "brands/new",
  ManageBrand: "brands/:id",
  Team: "team",
  Print: "print",
  DiningRDIntegration: "drd",
  DesignUpdater: "design-updater"
};
